import { fieldsEnabled } from '../controllers/FieldsController';
import Tool, { simpleToolButton } from './Tool';

class ToolFields extends Tool {
  static toolName = 'Fields';

  static action({ controller }) {
    controller.actionShowDrawerPath(`/selection`);
  }

  static available() {
    return fieldsEnabled();
  }

  static buttonComponent() {
    return simpleToolButton(ToolFields, 'fa-regular fa-sidebar-flip');
  }
}

export { ToolFields };
